import {Component, OnInit} from '@angular/core';
import {Constant} from '../../../../global/util/Constant';
import {DocumentState} from '../../../../global/util/DocumentState';
import {Document} from '../../../model/Document';
import {InformType} from '../../../../global/util/enum/InformType';
import {Page} from '../../../../global/util/enum/Page';
import {DocumentService} from '../../../service/document.service';
import {AuthService} from '../../../service/auth/auth.service';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {Dialog} from '../../../../global/util/Dialog';
import {ApplicationService} from '../../../service/application.service';
import {Router} from '@angular/router';
import {MailtemplateService} from '../../../service/mailtemplate.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {StringUtil} from '../../../../global/util/StringUtil';
import {Observationcancel} from '../../../model/Observationcancel';
import {ViewObservationCancelComponent} from '../view-observation-cancel/view-observation-cancel.component';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {State} from '../../../model/State';
import {CloneTool} from '../../../../global/util/CloneTool';
import {SearchDocument} from '../../../model/search/SearchDocument';
import {TranslateService} from '@ngx-translate/core';
import {Pagination} from '../../../../global/util/Pagination';

// TODO Falta refactorizar código
@Component({
  selector: 'app-list-invited-document',
  templateUrl: './list-invited-document.component.html',
  styleUrls: ['./list-invited-document.component.css']
})
export class ListInvitedDocumentComponent implements OnInit {

  public documents: Document[] = [];
  public page: any = {};
  public links: any = {};
  private documentUrl: string;
  public enumPage = Page;
  public loading: boolean;
  public title = 'TITLE.DOCUMENTS';
  private selectedDocuments: Document[] = [];
  public loadingDownload = false;
  public searchDocument = new SearchDocument();
  public states: State[] = [];
  public myPendingState: State = new State();
  public selectedStates: State[] = [];
  public loadingShowBy = false;
  pageNumber: any;
  pageNumbers: any;

  constructor(private router: Router,
              private modalService: NgbModal,
              private documentService: DocumentService,
              private authenticationService: AuthService,
              private applicationService: ApplicationService,
              private mailtemplateService: MailtemplateService,
              private translate: TranslateService) {
    this.loadInitialData();
  }

  ngOnInit() {
    this.pageNumbers = Pagination.getNumbers();
    this.pageNumber = this.pageNumbers[0].value;
  }

  private loadInitialData(): void {
    this.loading = true;
    const url = Constant.ROOT_API_V1 + '/states';
    this.applicationService.get(url).subscribe((value: any) => {
      this.loading = false;
      this.states = value._embedded.states.filter(state => state.id === DocumentState.MY_PENDINGS ||
        state.id === DocumentState.FINISHED ||
        state.id === DocumentState.PENDING ||
        state.id === DocumentState.ALL);
      this.stablishMyPendingState();
      this.pushDefaultState();
      this.search();
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.OBTAINING-DOCUMENT-STATES'));
    });
  }

  public loadDocuments(page: Page, documentCode?: string, documentNumber?: string, subject?: string, stateIdentifiers?: string): void {
    documentCode = documentCode ? documentCode.trim() : '';
    documentNumber = documentNumber ? documentNumber.trim() : '';
    subject = subject ? subject.trim() : '';
    stateIdentifiers = stateIdentifiers ? stateIdentifiers.trim() : '';
    switch (page) {
      case Page.First:
        this.documentUrl = Constant.ROOT_API_V1
          .concat('/documents/search?',
            'documentType=',
            documentCode,
            '&documentNumber=',
            documentNumber,
            '&subject=',
            subject,
            '&states=',
            stateIdentifiers,
            '&size=' + this.pageNumber + '&sort=createAt,desc');
        break;
      case Page.Previous:
        this.documentUrl = this.links.prev.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Next:
        this.documentUrl = this.links.next.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Last:
        this.documentUrl = this.links.last.href.replace('http', Constant.SCHEMA);
        break;
      default:
        this.documentUrl = this.links.self.href.replace('http', Constant.SCHEMA);
        break;
    }
    if (this.authenticationService.isAuthenticated()) {
      this.getDocuments(this.documentUrl);
    }
  }

  private getDocuments(url: string) {
    this.loading = true;
    this.documentService.get(url).subscribe((next: any) => {
      this.loadingShowBy = this.loading = false;
      if (next._embedded) {
        this.documents = next._embedded.documents;
      } else {
        this.documents = [];
      }
      this.page = next.page;
      this.links = next._links;
    }, error => {
      this.loading = false;
      this.processError(this.translate.instant('TITLE.DOCUMENTS'), error);
    });
  }

  public addOrRemove(event, document: Document) {
    if (event.target.checked) {
      this.selectedDocuments.push(document);
    } else {
      const index = this.getIndexOf(document);
      this.selectedDocuments.splice(index, 1);
    }
  }

  public wasSelected(document: Document): boolean {
    return this.isAdded(document);
  }

  private isAdded(document: Document): boolean {
    return this.selectedDocuments.find(value => value.id === document.id) !== undefined;
  }

  private getIndexOf(document: Document): number {
    return this.selectedDocuments.findIndex(value => value.id === document.id);
  }

  public addOrRemoveAll(event) {
    if (event.target.checked) {
      this.documents.filter(document => !this.isAdded(document)).forEach(document => this.selectedDocuments.push(document));
    } else {
      this.documents.filter(document => this.isAdded(document)).forEach(document => this.selectedDocuments.splice(this.getIndexOf(document), 1));
    }
  }

  public wasAllSelected(): boolean {
    if (this.selectedDocuments.length === 0) {
      return false;
    }
    return !(this.documents.find(document => !this.isAdded(document)) !== undefined);
  }

  public downloadOf(document1: Document) {
    const url = document1._links.stream.href.replace('http', Constant.SCHEMA);
    const more = document1._more;
    this.documentService.download(url).subscribe(next => {
      const control = document.createElement('a');
      control.setAttribute('style', 'display:none;');
      document.body.appendChild(control);
      control.href = window.URL.createObjectURL(next);
      control.download = more.basenameFile.concat(more.suffix === undefined ? '' : more.suffix, '.', more.extension);
      control.click();
    }, error => {
      const title = this.translate.instant('TITLE.DOWNLOAD-DOCUMENTS');
      this.processError(title, error);
    });
  }

  public wasCanceled(document: any): boolean {
    return Constant.INACTIVE === document.active || DocumentState.CANCELED === document.stateId;
  }

  get isEmptySelectedList(): boolean {
    return this.selectedDocuments.length === 0;
  }

  public hasComment(document: any): boolean {
    if (document._more) {
      return Constant.HAS_COMMENT === document._more.hasComment || this.wasCanceled(document) || this.wasModified(document);
    }
  }

  public viewObservation(document: Document) {
    const documentId = document.id;
    let url;
    if (this.wasModified(document)) {
      url = Constant.ROOT_API_V1.concat('/documents/', String(documentId), '/obsmodification');
    } else {
      url = Constant.ROOT_API_V1.concat('/documents/', String(documentId), '/obscancel');
    }
    this.loading = true;
    this.documentService.get(url).subscribe((observation: Observationcancel) => {
      this.loading = false;
      this.openModalViewObservation(document, observation);
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.DOCUMENTS'));
    });
  }

  public openModalViewObservation(document?: any, observationcancel?: Observationcancel) {
    const modalRef = this.modalService.open(ViewObservationCancelComponent, {size: 'lg'});
    modalRef.componentInstance.observationcancel = observationcancel;
    modalRef.componentInstance.document = document;
  }

  public view(document: Document) {
    window.open(document._more.resources[0].url3, '_blank');
  }

  public hasRole(roleDescription: string) {
    return this.authenticationService.hasRole(roleDescription);
  }

  public wasAttended(document: Document): boolean {
    return DocumentState.ATTENDED === document.stateId;
  }

  public wasDelivered(document: Document): boolean {
    return DocumentState.DELIVERED === document.stateId;
  }

  public wasFinished(document: Document): boolean {
    return DocumentState.FINISHED === document.stateId;
  }

  public wasMailSent(document: Document): boolean {
    return DocumentState.ATTACH_SENT === document.stateId;
  }

  public wasModified(document: Document): boolean {
    return Constant.ACTIVE === document.active && DocumentState.MODIFIED === document.stateId;
  }

  public getSpanClass(document: any): string {
    if (this.wasAttended(document)) {
      return 'badge badge-success';
    } else if (this.wasDelivered(document)) {
      return 'badge badge-warning';
    } else if (this.wasFinished(document)) {
      return 'badge badge-info';
    } else if (this.wasCanceled(document)) {
      return 'badge badge-danger';
    } else if (this.wasMailSent(document)) {
      return 'badge custom-badge-attach-sent';
    } else if (this.wasModified(document)) {
      return 'badge custom-badge-modified';
    } else {
      return '';
    }
  }

  get isInvited(): boolean {
    return this.authenticationService.isInvited;
  }

  public downloadMultipleDocuments() {
    const url = Constant.ROOT_API_V1
      .concat('/invited-user/documents/stream');
    const docIdentifiers = StringUtil.concatIdentifiers(this.selectedDocuments);
    const formData = new FormData();
    formData.append('docIdentifiers', docIdentifiers);
    this.loadingDownload = true;
    this.documentService.getMultipleDocuments(url, formData).subscribe(next => {
      this.loadingDownload = false;
      const control = document.createElement('a');
      control.setAttribute('style', 'display:none;');
      document.body.appendChild(control);
      control.href = window.URL.createObjectURL(next);
      const now = new Date();
      const s = this.format1(now.getUTCDate()) + '-' + this.format1(now.getUTCMonth() + 1) + '-' + now.getFullYear();
      control.download = 'IOFESign-' + s + '-signed.zip';
      control.click();
    }, error => {
      this.loadingDownload = false;
      const title = this.translate.instant('TITLE.DOWNLOAD-DOCUMENTS');
      this.processError(title, error);
    });
  }

  /**
   * Formatea los números que sean menores a 10 agregándole un '0'
   * @param val
   * @private
   */
  private format1(val: number): string {
    return val < 10 ? '0' + val : String(val);
  }

  public getBadgeTextBy(document: any): string {
    if (DocumentState.CANCELED === document.stateId) {
      return 'badge-danger';
    } else if (DocumentState.MODIFIED === document.stateId) {
      return 'custom-badge-modified';
    } else {
      const commentsInfo: any[] = document._more.commentsInfo;
      if (commentsInfo) {
        const commentObserved = commentsInfo.find(value => Constant.OBSERVED === value.observed);
        if (commentObserved) {
          return 'badge-warning';
        } else {
          return 'badge-info';
        }
      }
    }
  }

  private processError(title: string, error: any) {
    const status = error.status;
    if (status) {
      if (HttpStatusCode.UNAUTHORIZED === status) {
        Dialog.show(InformType.Danger, title, error.error.message);
      } else if (HttpStatusCode.FORBIDDEN === status) {
        Dialog.show(InformType.Info, this.translate.instant('TITLE.SESSION-EXPIRED'), this.translate.instant('MESSAGE.SESSION-EXPIRED'));
        this.logout();
      } else {
        Dialog.show(InformType.Danger, title, error.error.message);
      }
    } else {
      Dialog.show(InformType.Danger, title, error.error.message);
    }
  }

  private logout() {
    this.applicationService.setUserLoggedIn(false);
    this.router.navigate(['login']);
  }

  search(): void {
    this.documents = [];
    const documentCode = LocalStorage.getIdentificationDocumentCode();
    const documentNumber = LocalStorage.getUserDocumentNumber();
    const subject = this.searchDocument.subject;
    const stateIdentifiers = this.removeInnecesaryStateIds(StringUtil.concatIdentifiers2(this.selectedStates, ','));
    this.loadDocuments(Page.First, documentCode, documentNumber, subject, stateIdentifiers);
  }

  public wasSelected2(state: State): boolean {
    if (DocumentState.ALL === state.id) {
      return this.selectedStates.length === this.states.length || this.otherWasSelected();
    }
    return this.selectedStates.find(value => value.id === state.id) !== undefined;
  }

  public addRemoveState(event, state: State) {
    this.loadingShowBy = true;
    if (DocumentState.MY_PENDINGS === state.id) {
      if (event.target.checked) {
        this.selectedStates = [];
        this.selectedStates.push(this.myPendingState);
      } else {
        this.pushDefaultStateValue4Adms();
      }
    } else {
      if (event.target.checked) {
        const index = this.selectedStates.findIndex(value => DocumentState.MY_PENDINGS === value.id);
        if (index !== -1) {
          this.selectedStates.splice(index, 1);
        }
        if (DocumentState.ALL === state.id) {
          for (const state1 of this.states) {
            if (!this.wasSelected2(state1)) {
              const clonedState = CloneTool.do(state1);
              this.selectedStates.push(clonedState);
            }
          }
        } else {
          this.selectedStates.push(state);
        }
      } else {
        if (DocumentState.ALL !== state.id && DocumentState.MY_PENDINGS !== state.id) {
          const index = this.selectedStates.findIndex(value => DocumentState.ALL === value.id);
          if (index !== -1) {
            this.selectedStates.splice(index, 1);
          }
        }
        if (this.selectedStates.length === 1) {
          this.loadingShowBy = false;
          event.target.checked = true;
          return;
        }
        if (DocumentState.ALL === state.id) {
          this.pushDefaultState();
        } else {
          const index = this.getIndexOfState(state);
          this.selectedStates.splice(index, 1);
        }
      }
    }
    this.search();
  }

  private pushDefaultStateValue4Adms() {
    this.selectedStates = [];
    this.states.forEach(state => {
      if (DocumentState.MY_PENDINGS !== state.id) {
        const state1 = CloneTool.do(state);
        this.selectedStates.push(state1);
      }
    });
  }

  /**
   * Establece al estado 'finalizado' como el seleccionado por defecto
   * @private
   */
  private pushDefaultState() {
    this.selectedStates = [];
    const finished = this.states.find(value => value.id === DocumentState.FINISHED);
    this.selectedStates.push(finished);
  }

  private getIndexOfState(state: State): number {
    return this.selectedStates.findIndex(value => value.id === state.id);
  }

  private otherWasSelected() {
    const clonedStates: State[] = CloneTool.doList(this.states);
    for (let index = 0; index < clonedStates.length; index++) {
      const state = clonedStates[index];
      if (DocumentState.ALL === state.id) {
        clonedStates.splice(index, 1);
      }
    }
    for (const state of clonedStates) {
      if (!this.wasSelected2(state)) {
        return false;
      }
    }
    return true;
  }

  private stablishMyPendingState() {
    this.myPendingState = CloneTool.do(this.states.find(value => value.id === DocumentState.MY_PENDINGS));
    const index = this.states.findIndex(value => DocumentState.MY_PENDINGS === value.id);
    this.states.splice(index, 1);
  }

  private removeInnecesaryStateIds(identifiers: string) {
    return identifiers.split(',').filter(identifier => DocumentState.ALL !== +identifier).join(',');
  }
}
